import { acceptHMRUpdate, defineStore } from "pinia";

export interface ContextmenuAction {
  title: string; // usable as key, should be unique
  class?: string;
  callback: (arg?: unknown) => unknown;
}

export const useRightClickMenu = defineStore("ui/rightclickMenu", {
  state: () => ({
    actions: [] as ContextmenuAction[],
    x: 0,
    y: 0
  }),

  getters: {
    isVisible(state) {
      return state.actions.length > 0;
    }
  },

  actions: {
    /**
     * Show a right click menu
     */
    show({
      actions,
      x,
      y
    }: {
      actions: ContextmenuAction[];
      x: number;
      y: number;
    }) {
      this.setPosition({
        x,
        y
      });
      this.setActions(actions);
    },

    hide() {
      this.setActions([]);
    },

    setPosition({ x, y }: { x: number; y: number }) {
      this.$patch((state) => {
        state.x = x;
        state.y = y;
      });
    },

    setActions(actions: ContextmenuAction[]) {
      this.actions = actions;
    }
  }
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useRightClickMenu, import.meta.hot));
}
